module.exports = __webpack_public_path__ + "img/ball_metascan.d429975d.png";